import UndoOutlinedIcon from "@mui/icons-material/UndoOutlined";
import { ConfirmDialog } from "../../shared/ui";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
}

export function RetractConfirmationDialog({ open, onClose, onConfirm, loading }: Props) {
  return (
    <ConfirmDialog
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      tone="info"
      icon={<UndoOutlinedIcon />}
      confirmStartIcon={<UndoOutlinedIcon />}
      maxWidth={480}
      title="Retract rejection?"
      description={
        <>
          The report returns to <strong>In CO Review</strong>. All existing
          comments are preserved. If the officer is already revising the
          report, their work is unaffected.
        </>
      }
      confirmLabel="Retract rejection"
      loading={loading}
    />
  );
}
